const createImagePreloader = (maxConcurrent: number = 5) => {
    const imagePool: HTMLImageElement[] = Array.from(
        { length: maxConcurrent },
        () => new Image()
    )
    let activeCount = 0

    const preloadImage = (src: string): Promise<boolean> => {
        if (!src) {
            return Promise.reject(new Error("图片地址为空"))
        }

        return new Promise((resolve, reject) => {
            const load = () => {
                if (activeCount >= maxConcurrent) {
                    // 等待其他任务完成
                    setTimeout(load, 50)
                    return
                }

                activeCount++

                const img = imagePool.pop() || new Image()

                img.onload = () => {
                    activeCount--
                    imagePool.push(img) // 加载完成后归还到池中
                    resolve(true)
                }

                img.onerror = () => {
                    activeCount--
                    imagePool.push(img)
                    reject(new Error(`图片加载失败: ${src}`))
                }

                img.src = src
            }

            load()
        })
    }

    return {
        preloadImage,
        getPoolSize: () => imagePool.length,
        getActiveCount: () => activeCount,
    }
}

export const preloadImage = createImagePreloader(5).preloadImage
export const preloadImageElement = async (
    src: string
): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
            resolve(img)
        }
        img.onerror = () => {
            reject(new Error("图片加载失败"))
        }
        img.src = src
    })
}

const loadImageCache: Record<string, HTMLImageElement> = {}
/**
 * canvas用, 有缓存
 */
export const loadImageAnonymous = async (
    src: string
): Promise<HTMLImageElement> => {
    if (/^https?:\/\//.test(src)) {
        const url = new URL(src)
        url.searchParams.set("load_by", "script")
        src = url.href
    }
    if (loadImageCache[src]) {
        return loadImageCache[src]
    }
    return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = "anonymous"
        img.onload = () => {
            resolve(img)
            loadImageCache[src] = img
        }
        img.onerror = () => {
            reject(new Error("图片加载失败"))
        }
        img.src = src
    })
}
